import FowsalProfile from "../../../assets/Fowsal.png";

export const MarketResearchTeamProfile = [
  { id: 1, title: "Fowsal S", imgUrl: FowsalProfile },
];
